import { cn } from "@unlikelyai-magic/utils";

/**
 * Metric card component for displaying statistics
 */
interface MetricCardProps {
  icon: React.ReactNode;
  value: string;
  label: string;
  timeframe?: string;
  className?: string;
}

export const MetricCard = ({
  icon,
  value,
  label,
  timeframe,
  className,
}: MetricCardProps) => (
  <div
    className={cn(
      "bg-brand-card border border-brand-border rounded-[14px] p-4 shadow-sm flex flex-col gap-2",
      className
    )}
  >
    <div className="flex gap-2 items-center">
      <div className="relative shrink-0 w-8 h-8">
        <div className="absolute inset-0 bg-brand-primary opacity-15 rounded-[6px]" />
        <div className="absolute left-2 top-2 w-4 h-4 text-brand-primary">
          {icon}
        </div>
      </div>
      <p className="text-2xl font-normal leading-8 text-brand-foreground">
        {value}
      </p>
    </div>
    <div className="flex flex-col gap-2">
      <p className="text-base font-semibold leading-6 text-brand-foreground">
        {label}
      </p>
      {timeframe && (
        <p className="text-sm font-normal leading-5 text-brand-muted">
          {timeframe}
        </p>
      )}
    </div>
  </div>
);
